// dwaar/src/lib/nav.js
// Repo: terralekha-core | Folder: dwaar/src/lib/
// Thin wrapper around window.location to allow vi.mock() in vitest tests.
//
// jsdom marks window.location properties as non-configurable, so
// vi.spyOn(window.location, "replace") throws "Cannot redefine property".
// Wrapping the call here gives tests a single mockable import.

export function navigateTo(url) {
  window.location.replace(url);
}
